<script setup>
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    text: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["update:modelValue", "cancelButtonClose", "cancel"]);

const cancelButtonClose = () => {
    emit("cancelButtonClose");
    emit("update:modelValue", false);
};

const handleYes = () => {
    emit("cancel");
    emit("update:modelValue", false);
};
</script>

<template>
    <el-dialog
        v-model="props.modelValue"
        width="489px"
        class="request-doc-dialog client-dialog standalone-dialog cancel-modal" align-center
        :show-close="false"
    >
        <div class="text-center">
            <svg
                width="150"
                height="105"
                viewBox="0 0 150 105"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="margin-bottom: 20px"
            >
                <rect
                    y="0.5"
                    width="150"
                    height="104"
                    rx="52"
                    fill="url(#pattern0_9619_65919)"
                />
                <defs>
                    <pattern
                        id="pattern0_9619_65919"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                    >
                        <use
                            xlink:href="#image0_9619_65919"
                            transform="matrix(0.00666667 0 0 0.00961538 0 -0.221154)"
                        />
                    </pattern>
                    <image
                        id="image0_9619_65919"
                        width="150"
                        height="150"
                        preserveAspectRatio="none"
                        xlink:href="data:image/png;base64,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"
                    />
                </defs>
            </svg>

            <h2 class="fw-bold" style="color: #d92d20; font-size: 24px">
                {{ $t("messages.cancel") }} {{ props.text }}
            </h2>

            <h6 style="color: #666; font-size: 16px">
                {{ $t("messages.this_will_discard_your_current_progress") }}
            </h6>
        </div>

        <template #footer>
            <span
                class="dialog-footer d-flex align-items-center justify-content-center"
                style="gap: 12px"
            >
                <button
                    type="button"
                    style="width: 204.5px"
                    class="btn btn-outline-secondary border px-4 py-3 text-dark"
                    @click="cancelButtonClose"
                >
                    Back
                </button>

                <button
                    type="button"
                    class="btn px-4 py-3"
                    style="
                        width: 204.5px;
                        background-color: #d92d20;
                        color: white;
                        border: none;
                    "
                    @click="handleYes"
                >
                    Yes, Cancel
                </button>
            </span>
        </template>
    </el-dialog>
</template>
<style scoped>
</style>